import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-27494590")

_pushScopeId("data-v-27494590")
const _hoisted_1 = {
  key: 0,
  class: "accept_protocol_mask"
}
const _hoisted_2 = { class: "accept_protocol_container" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "title" }, "确认开通", -1)
const _hoisted_4 = { class: "content" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 我已阅读并同意 ")
const _hoisted_6 = { class: "btn_group" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.visible)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("span", {
              class: "link",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openUserProtocol && _ctx.openUserProtocol(...args)))
            }, "《用户协议》"),
            _createVNode("span", {
              class: "link",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openPrivacyProtocol && _ctx.openPrivacyProtocol(...args)))
            }, "《隐私政策》")
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", {
              class: "common_bottom_btn confirm_btn",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
            }, "同意并开通"),
            _createVNode("div", {
              class: "common_bottom_btn cancel_btn",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
            }, "取消")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
})